import type { RouteObject } from "react-router";
import { Navigate } from "react-router";
import { GROUP_ROUTES } from "@/src/group/constants/group-routes";

export const groupRoutes: RouteObject = {
	children: [
		{
			path: GROUP_ROUTES.GROUPS,
			lazy: async () => {
				const { default: GroupsPage } = await import("../pages/groups-page");
				return { Component: GroupsPage };
			},
		},
		{
			path: GROUP_ROUTES.LEGACY_DISCOVER,
			element: <Navigate to={GROUP_ROUTES.GROUPS} replace />,
		},
	],
};
